import React from 'react';
import { getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const { Cell } = Table;

const PathKeyCell = ({ dataKey, rowData, defaultValue, ...props }) => (
  <Cell {...props}>{getOr(defaultValue, dataKey, rowData)}</Cell>
);

PathKeyCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({}),
  defaultValue: PropTypes.string
};

PathKeyCell.defaultProps = {
  rowData: null,
  defaultValue: ''
};

export default PathKeyCell;
